import type { Transition } from "@uirouter/core";

import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

/**
 * onEnter hook that removes the comparedDuration parameter for states
 * that don't support period-over-period comparison.
 *
 * This hook is used for routes where periodOverPeriodEnabled is false.
 * It ensures that if a user navigates to these routes with a comparedDuration
 * parameter (e.g., from a different route), the parameter is cleaned up.
 */
export const onEnterRemoveComparedDuration = (transition: Transition): void => {
    const toState = transition.to() as IRouterState;
    const params = transition.params();

    if (!toState.periodOverPeriodEnabled && params.comparedDuration != null) {
        void proNavigator.go(toState.name, { ...params, comparedDuration: null }, { location: "replace" });
    }
};

